// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import LoadingSpinner from "../components/LoadingSpinner";
// import axios from "axios";
// import { useNavigate } from 'react-router-dom';

// // Constants
// const VIEW_TYPES = {
//   TOPUP: 'topup',
//   RENEW: 'renew',
//   MANUAL: 'manual'
// };

// const MANUAL_ACTIVATION_PARTNER_CODE = '112722282';

// const STATUS = {
//   INACTIVE: 'InActive',
//   RECHARGE: 'Recharge'
// };

// const FLAGS = {
//   RENEW: 1,
//   MANUAL: 2
// };

// const SuperadminRenewal = () => {
//   const [data, setData] = useState([]);
//   const [renewData, setRenewData] = useState([]);
//   const [manualData, setManualData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentView, setCurrentView] = useState(VIEW_TYPES.TOPUP);
//   const [actionTaken, setActionTaken] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [modalLoading, setModalLoading] = useState(false);

//   const apiUrl = process.env.REACT_APP_BASE_URL;
//   const navigate = useNavigate();

//   // Memoized token and partner code
//   const authToken = useMemo(() => localStorage.getItem("token"), []);
//   const partnerCode = useMemo(() => localStorage.getItem("partnerCode"), []);

//   // Fetch Top-up History
//   const fetchTopupHistory = useCallback(async () => {
//     try {
//       const response = await fetch(
//         `${apiUrl}ESIM/Get_topup_salereport?flag=1&partnercode=${partnerCode}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${authToken}`,
//           },
//         }
//       );
      
//       const result = await response.json();
      
//       if (result.isSuccess) {
//         setData(result.gettopup_sale || []);
//       }
//     } catch (err) {
//       console.error("Error fetching top-up data:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [apiUrl, partnerCode, authToken]);

//   // Generic Renew Data Fetcher
//   const fetchRenewDataGeneric = useCallback(async (partnerCodeParam, filterOutManual = false) => {
//     try {
//       const response = await axios.post(
//         `${apiUrl}Renew/GetRenewData`,
//         {
//           partnerCode: partnerCodeParam,
//           pageSize: 800,
//           pageIndex: 1,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "*/*",
//             ...(authToken && { Authorization: `Bearer ${authToken}` }),
//           },
//         }
//       );

//       if (response.data?.isSuccess) {
//         let dataToSet = response.data.renewData || [];
        
//         // Filter out manual activation partner code if needed
//         if (filterOutManual) {
//           dataToSet = dataToSet.filter(
//             item => item.partnerCode !== MANUAL_ACTIVATION_PARTNER_CODE
//           );
//         }
        
//         return dataToSet;
//       }
      
//       return [];
//     } catch (error) {
//       console.error("Error fetching renew data:", error);
//       return [];
//     }
//   }, [apiUrl, authToken]);

//   // Fetch Regular Renew Data (filtered)
//   const fetchRenewData = useCallback(async () => {
//     const data = await fetchRenewDataGeneric('string', true);
//     setRenewData(data);
//     setLoading(false);
//   }, [fetchRenewDataGeneric]);

//   // Fetch Manual Activation Data
//   const fetchManualActivationData = useCallback(async () => {
//     const data = await fetchRenewDataGeneric(MANUAL_ACTIVATION_PARTNER_CODE, false);
//     setManualData(data);
//     setLoading(false);
//   }, [fetchRenewDataGeneric]);

//   // Effect to fetch data based on current view
//   useEffect(() => {
//     setLoading(true);
    
//     switch (currentView) {
//       case VIEW_TYPES.TOPUP:
//         fetchTopupHistory();
//         break;
//       case VIEW_TYPES.RENEW:
//         fetchRenewData();
//         break;
//       case VIEW_TYPES.MANUAL:
//         fetchManualActivationData();
//         break;
//       default:
//         setLoading(false);
//     }
//   }, [currentView, actionTaken, fetchTopupHistory, fetchRenewData, fetchManualActivationData]);

//   // View Toggle Handlers
//   const handleViewChange = useCallback((viewType) => {
//     setCurrentView(viewType);
//   }, []);

//   // Status Update Handler
//   const handleStatusUpdate = useCallback(async () => {
//     setModalLoading(true);

//     // Determine flag based on current view
//     const flag = currentView === VIEW_TYPES.MANUAL ? FLAGS.MANUAL : FLAGS.RENEW;

//     const payload = {
//       orderID: selectedOrder.orderID,
//       status: STATUS.RECHARGE,
//       flag,
//     };

//     try {
//       const response = await axios.post(
//         `${apiUrl}Renew/UpdateRenewStatus`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${authToken}`,
//           },
//         }
//       );

//       if (response.data?.isSuccess) {
//         setActionTaken(prev => !prev);
//         setModalVisible(false);
//         // Optional: Show success message
//         alert('Status updated successfully!');
//       } else {
//         alert("Failed to update status.");
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       alert(error.response?.data?.message || "Error occurred while updating status.");
//     } finally {
//       setModalLoading(false);
//     }
//   }, [apiUrl, authToken, currentView, selectedOrder]);

//   // CSV Download Utility
//   const downloadCSV = useCallback((dataToDownload, filename) => {
//     if (!dataToDownload || dataToDownload.length === 0) {
//       alert("No data available to download");
//       return;
//     }

//     const headers = Object.keys(dataToDownload[0]);
//     const csvRows = [headers.join(',')];
    
//     dataToDownload.forEach(item => {
//       const row = headers.map(header => {
//         const value = item[header] ?? '';
//         const escapedValue = String(value).replace(/"/g, '""');
//         return `"${escapedValue}"`;
//       });
//       csvRows.push(row.join(','));
//     });

//     const csvContent = csvRows.join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     const url = URL.createObjectURL(blob);
    
//     link.setAttribute('href', url);
//     link.setAttribute('download', filename);
//     link.style.visibility = 'hidden';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     URL.revokeObjectURL(url);
//   }, []);

//   // CSV Download Handlers
//   const handleDownloadCSV = useCallback(() => {
//     const timestamp = new Date().toISOString().split('T')[0];
//     let dataToDownload, prefix;

//     switch (currentView) {
//       case VIEW_TYPES.TOPUP:
//         dataToDownload = data;
//         prefix = 'topup';
//         break;
//       case VIEW_TYPES.RENEW:
//         dataToDownload = renewData;
//         prefix = 'renew';
//         break;
//       case VIEW_TYPES.MANUAL:
//         dataToDownload = manualData;
//         prefix = 'manual_activation';
//         break;
//       default:
//         return;
//     }

//     downloadCSV(dataToDownload, `${prefix}_data_${timestamp}.csv`);
//   }, [currentView, data, renewData, manualData, downloadCSV]);

//   // Modal Handlers
//   const handleOpenModal = useCallback((order) => {
//     setSelectedOrder({
//       orderID: order.orderID,
//       status: order.status === STATUS.RECHARGE ? STATUS.INACTIVE : STATUS.RECHARGE,
//     });
//     setModalVisible(true);
//   }, []);

//   const handleCloseModal = useCallback(() => {
//     setModalVisible(false);
//     setSelectedOrder(null);
//   }, []);

//   // View Title and Button Labels
//   const viewConfig = useMemo(() => ({
//     [VIEW_TYPES.TOPUP]: {
//       title: "Top-Up Plans",
//       hasData: data.length > 0
//     },
//     [VIEW_TYPES.RENEW]: {
//       title: "Renew Data Table",
//       hasData: renewData.length > 0
//     },
//     [VIEW_TYPES.MANUAL]: {
//       title: "Manual Activation Data",
//       hasData: manualData.length > 0
//     }
//   }), [data.length, renewData.length, manualData.length]);

//   // Render Action Button
//   const renderActionButton = useCallback((item) => {
//     const isInactive = item.status === STATUS.INACTIVE;
    
//     return (
//       <button
//         onClick={() => handleOpenModal(item)}
//         className={`px-4 py-1 rounded text-white transition ${
//           isInactive ? "bg-red-500 hover:bg-red-600" : "bg-green-400 hover:bg-green-500"
//         }`}
//       >
//         {isInactive ? "Action Pending" : "Renewed"}
//       </button>
//     );
//   }, [handleOpenModal]);

//   // Render Renew/Manual Table
//   const renderDataTable = useCallback((tableData) => (
//     <div className="overflow-x-auto">
//       <table className="min-w-full bg-white border border-gray-200 text-sm">
//         <thead>
//           <tr className="bg-gray-100 text-left">
//             <th className="p-2 border">Order ID</th>
//             <th className="p-2 border">Partner Code</th>
//             <th className="p-2 border">ICCID</th>
//             <th className="p-2 border">Plan Name</th>
//             <th className="p-2 border">Renewal Days</th>
//             <th className="p-2 border">Buy Amount</th>
//             <th className="p-2 border">Renew  Amount</th>
//            <th className="p-2 border">Purchase Date</th>
//           <th className="p-2 border">Request Date</th>
//             <th className="p-2 border">New Expiry</th>
//             <th className="p-2 border">Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {tableData.length > 0 ? (
//             tableData.map((item) => (
//               <tr key={item.id || item.orderID} className="hover:bg-gray-50">
//                 <td className="p-2 border">{item.orderID}</td>
//                 <td className="p-2 border">{item.partnerCode}</td>
//                 <td className="p-2 border">{item.iccid}</td>
//                 <td className="p-2 border">{item.planName}</td>
//                 <td className="p-2 border">{item.renewalDays} Days</td>
//                 <td className="p-2 border">${parseFloat(item.buyAmount).toFixed(2)}</td>
//                 <td className="p-2 border">${parseFloat(item.userAmount).toFixed(2)}</td>
//                 <td>{new Date(item.purchaseDate).toLocaleDateString()}</td>
//                  <td className="p-2 border">
//                   {new Date(item.createdDate).toLocaleDateString()}
//                 </td>
//                 <td className="p-2 border">
//                   {new Date(item.newExpiryDate).toLocaleDateString()}
//                 </td>
               
//                 <td className="p-2 border">
//                   {renderActionButton(item)}
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td className="p-2 border text-center text-gray-500" colSpan="10">
//                 No data available.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   ), [renderActionButton]);

//   // Render Top-Up Table
//   const renderTopupTable = useCallback(() => (
//     <table className="w-full bg-white border rounded-lg shadow text-sm">
//       <thead className="bg-gray-100">
//         <tr className="border-b">
//           <th className="text-center p-3 px-5">Plan Name</th>
//           <th className="text-center p-3 px-5">Created Date</th>
//           <th className="text-center p-3 px-5">Price</th>
//           <th className="text-center p-3 px-5">Email</th>
//           <th className="text-center p-3 px-5">ICCID</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data.length === 0 ? (
//           <tr>
//             <td colSpan="5" className="text-center py-4 text-gray-500">
//               No top-up plans available.
//             </td>
//           </tr>
//         ) : (
//           data.map((item, index) => (
//             <tr key={index} className="hover:bg-gray-50">
//               <td className="text-center p-3 px-5">{item.planname}</td>
//               <td className="text-center p-3 px-5">{item.createddate}</td>
//               <td className="text-center p-3 px-5">${item.price}.00</td>
//               <td className="text-center p-3 px-5">{item.email}</td>
//               <td className="text-center p-3 px-5">{item.iccid?.trim()}</td>
//             </tr>
//           ))
//         )}
//       </tbody>
//     </table>
//   ), [data]);

//   return (
//     <div className="p-6 overflow-x-auto relative">
//       {/* Header Section */}
//       <div className="flex justify-between items-center mb-4 flex-wrap gap-3">
//         <h1 className="text-2xl font-bold">
//           {viewConfig[currentView]?.title}
//         </h1>
        
//         <div className="flex gap-2 flex-wrap">
//           {/* Download CSV Button */}
//           <button
//             onClick={handleDownloadCSV}
//             className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded shadow flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//             disabled={loading || !viewConfig[currentView]?.hasData}
//           >
//             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//             </svg>
//             Download CSV
//           </button>

//           {/* View Toggle Buttons */}
//           <button
//             onClick={() => handleViewChange(VIEW_TYPES.TOPUP)}
//             className={`px-4 py-2 rounded shadow transition ${
//               currentView === VIEW_TYPES.TOPUP
//                 ? "bg-blue-600 text-white"
//                 : "bg-gray-200 hover:bg-gray-300 text-gray-700"
//             }`}
//           >
//             Top-Up History
//           </button>

//           <button
//             onClick={() => handleViewChange(VIEW_TYPES.RENEW)}
//             className={`px-4 py-2 rounded shadow transition ${
//               currentView === VIEW_TYPES.RENEW
//                 ? "bg-blue-600 text-white"
//                 : "bg-gray-200 hover:bg-gray-300 text-gray-700"
//             }`}
//           >
//             Renew Data
//           </button>

//           <button
//             onClick={() => handleViewChange(VIEW_TYPES.MANUAL)}
//             className={`px-4 py-2 rounded shadow transition ${
//               currentView === VIEW_TYPES.MANUAL
//                 ? "bg-blue-600 text-white"
//                 : "bg-gray-200 hover:bg-gray-300 text-gray-700"
//             }`}
//           >
//             Manual Activation
//           </button>
//         </div>
//       </div>

//       {/* Content Section */}
//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <>
//           {currentView === VIEW_TYPES.TOPUP && renderTopupTable()}
//           {currentView === VIEW_TYPES.RENEW && renderDataTable(renewData)}
//           {currentView === VIEW_TYPES.MANUAL && renderDataTable(manualData)}
//         </>
//       )}

//       {/* Modal */}
//       {modalVisible && selectedOrder && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow-lg p-6 w-96 relative">
//             <h2 className="text-lg font-semibold mb-4">
//               {currentView === VIEW_TYPES.MANUAL ? "Update Manual Activation Status" : "Update Renewal Status"}
//             </h2>
//             <p className="mb-2">
//               Order ID: <strong>{selectedOrder.orderID}</strong>
//             </p>
//             <p className="mb-4 text-sm text-gray-600">
//               Flag: <strong>{currentView === VIEW_TYPES.MANUAL ? FLAGS.MANUAL : FLAGS.RENEW}</strong>
//             </p>
//             <div className="flex justify-between mt-6 gap-2">
//               <button
//                 onClick={handleStatusUpdate}
//                 disabled={modalLoading}
//                 className="px-4 py-2 rounded text-white bg-blue-500 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed flex-1"
//               >
//                 {modalLoading ? "Updating..." : "Confirm Update"}
//               </button>
//               <button
//                 onClick={handleCloseModal}
//                 disabled={modalLoading}
//                 className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-black disabled:opacity-50 flex-1"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SuperadminRenewal;



import React, { useEffect, useState, useCallback, useMemo } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

// Constants
const VIEW_TYPES = {
  TOPUP: 'topup',
  RENEW: 'renew',
  MANUAL: 'manual'
};

const MANUAL_ACTIVATION_PARTNER_CODE = '112722282';

const STATUS = {
  INACTIVE: 'InActive',
  RECHARGE: 'Recharge'
};

const FLAGS = {
  RENEW: 1,
  MANUAL: 2
};

// Toast Component
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === 'success' ? 'bg-green-500' : type === 'error' ? 'bg-red-500' : 'bg-blue-500';

  return (
    <div className={`fixed top-4 right-4 z-[100] ${bgColor} text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in`}>
      {type === 'success' && (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      )}
      {type === 'error' && (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      )}
      <span>{message}</span>
      <button 
        onClick={onClose}
        className="ml-2 hover:bg-white/20 rounded p-1 transition"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

const SuperadminRenewal = () => {
  const [data, setData] = useState([]);
  const [renewData, setRenewData] = useState([]);
  const [manualData, setManualData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentView, setCurrentView] = useState(VIEW_TYPES.TOPUP);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  
  // Toast state
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const apiUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // Memoized token and partner code
  const authToken = useMemo(() => localStorage.getItem("token"), []);
  const partnerCode = useMemo(() => localStorage.getItem("partnerCode"), []);

  // Show Toast Helper
  const showToast = useCallback((message, type = 'success') => {
    setToast({ show: true, message, type });
  }, []);

  // Hide Toast Helper
  const hideToast = useCallback(() => {
    setToast({ show: false, message: '', type: 'success' });
  }, []);

  // Fetch Top-up History
  const fetchTopupHistory = useCallback(async () => {
    try {
      const response = await fetch(
        `${apiUrl}ESIM/Get_topup_salereport?flag=1&partnercode=${partnerCode}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      
      const result = await response.json();
      
      if (result.isSuccess) {
        setData(result.gettopup_sale || []);
      }
    } catch (err) {
      console.error("Error fetching top-up data:", err);
      showToast("Error fetching top-up data", "error");
    } finally {
      setLoading(false);
    }
  }, [apiUrl, partnerCode, authToken, showToast]);

  // Generic Renew Data Fetcher
  const fetchRenewDataGeneric = useCallback(async (partnerCodeParam, filterOutManual = false) => {
    try {
      const response = await axios.post(
        `${apiUrl}Renew/GetRenewData`,
        {
          partnerCode: partnerCodeParam,
          pageSize: 800,
          pageIndex: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            ...(authToken && { Authorization: `Bearer ${authToken}` }),
          },
        }
      );

      if (response.data?.isSuccess) {
        let dataToSet = response.data.renewData || [];
        
        // Filter out manual activation partner code if needed
        if (filterOutManual) {
          dataToSet = dataToSet.filter(
            item => item.partnerCode !== MANUAL_ACTIVATION_PARTNER_CODE
          );
        }
        
        return dataToSet;
      }
      
      return [];
    } catch (error) {
      console.error("Error fetching renew data:", error);
      showToast("Error fetching renew data", "error");
      return [];
    }
  }, [apiUrl, authToken, showToast]);

  // Fetch Regular Renew Data (filtered)
  const fetchRenewData = useCallback(async () => {
    const fetchedData = await fetchRenewDataGeneric('string', true);
    setRenewData(fetchedData);
    setLoading(false);
  }, [fetchRenewDataGeneric]);

  // Fetch Manual Activation Data
  const fetchManualActivationData = useCallback(async () => {
    const fetchedData = await fetchRenewDataGeneric(MANUAL_ACTIVATION_PARTNER_CODE, false);
    setManualData(fetchedData);
    setLoading(false);
  }, [fetchRenewDataGeneric]);

  // Effect to fetch data based on current view
  useEffect(() => {
    setLoading(true);
    
    switch (currentView) {
      case VIEW_TYPES.TOPUP:
        fetchTopupHistory();
        break;
      case VIEW_TYPES.RENEW:
        fetchRenewData();
        break;
      case VIEW_TYPES.MANUAL:
        fetchManualActivationData();
        break;
      default:
        setLoading(false);
    }
  }, [currentView, fetchTopupHistory, fetchRenewData, fetchManualActivationData]);

  // View Toggle Handlers
  const handleViewChange = useCallback((viewType) => {
    setCurrentView(viewType);
  }, []);

  // Update local state after successful status update
  const updateLocalState = useCallback((orderID, newStatus) => {
    if (currentView === VIEW_TYPES.RENEW) {
      setRenewData(prevData => 
        prevData.map(item => 
          item.orderID === orderID 
            ? { ...item, status: newStatus }
            : item
        )
      );
    } else if (currentView === VIEW_TYPES.MANUAL) {
      setManualData(prevData => 
        prevData.map(item => 
          item.orderID === orderID 
            ? { ...item, status: newStatus }
            : item
        )
      );
    }
  }, [currentView]);

  // Remove item from local state after successful update (optional - if you want to remove instead of update)
  const removeFromLocalState = useCallback((orderID) => {
    if (currentView === VIEW_TYPES.RENEW) {
      setRenewData(prevData => prevData.filter(item => item.orderID !== orderID));
    } else if (currentView === VIEW_TYPES.MANUAL) {
      setManualData(prevData => prevData.filter(item => item.orderID !== orderID));
    }
  }, [currentView]);

  // Status Update Handler
  const handleStatusUpdate = useCallback(async () => {
    if (!selectedOrder) return;
    
    setModalLoading(true);

    // Determine flag based on current view
    const flag = currentView === VIEW_TYPES.MANUAL ? FLAGS.MANUAL : FLAGS.RENEW;

    const payload = {
      orderID: selectedOrder.orderID,
      status: STATUS.RECHARGE,
      flag,
    };

    try {
      const response = await axios.post(
        `${apiUrl}Renew/UpdateRenewStatus`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data?.isSuccess) {
        // Update local state instead of triggering full re-fetch
        updateLocalState(selectedOrder.orderID, STATUS.RECHARGE);
        
        // Or if you want to remove the item from list:
        // removeFromLocalState(selectedOrder.orderID);
        
        setModalVisible(false);
        setSelectedOrder(null);
        
        // Show success toast
        showToast('Status updated successfully!', 'success');
      } else {
        showToast("Failed to update status.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast(
        error.response?.data?.message || "Error occurred while updating status.",
        "error"
      );
    } finally {
      setModalLoading(false);
    }
  }, [apiUrl, authToken, currentView, selectedOrder, updateLocalState, showToast]);

  // CSV Download Utility
  const downloadCSV = useCallback((dataToDownload, filename) => {
    if (!dataToDownload || dataToDownload.length === 0) {
      showToast("No data available to download", "error");
      return;
    }

    const headers = Object.keys(dataToDownload[0]);
    const csvRows = [headers.join(',')];
    
    dataToDownload.forEach(item => {
      const row = headers.map(header => {
        const value = item[header] ?? '';
        const escapedValue = String(value).replace(/"/g, '""');
        return `"${escapedValue}"`;
      });
      csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    showToast("CSV downloaded successfully!", "success");
  }, [showToast]);

  // CSV Download Handlers
  const handleDownloadCSV = useCallback(() => {
    const timestamp = new Date().toISOString().split('T')[0];
    let dataToDownload, prefix;

    switch (currentView) {
      case VIEW_TYPES.TOPUP:
        dataToDownload = data;
        prefix = 'topup';
        break;
      case VIEW_TYPES.RENEW:
        dataToDownload = renewData;
        prefix = 'renew';
        break;
      case VIEW_TYPES.MANUAL:
        dataToDownload = manualData;
        prefix = 'manual_activation';
        break;
      default:
        return;
    }

    downloadCSV(dataToDownload, `${prefix}_data_${timestamp}.csv`);
  }, [currentView, data, renewData, manualData, downloadCSV]);

  // Modal Handlers
  const handleOpenModal = useCallback((order) => {
    setSelectedOrder({
      orderID: order.orderID,
      status: order.status === STATUS.RECHARGE ? STATUS.INACTIVE : STATUS.RECHARGE,
    });
    setModalVisible(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalVisible(false);
    setSelectedOrder(null);
  }, []);

  // View Title and Button Labels
  const viewConfig = useMemo(() => ({
    [VIEW_TYPES.TOPUP]: {
      title: "Top-Up Plans",
      hasData: data.length > 0
    },
    [VIEW_TYPES.RENEW]: {
      title: "Renew Data Table",
      hasData: renewData.length > 0
    },
    [VIEW_TYPES.MANUAL]: {
      title: "Manual Activation Data",
      hasData: manualData.length > 0
    }
  }), [data.length, renewData.length, manualData.length]);

  // Render Action Button
  const renderActionButton = useCallback((item) => {
    const isInactive = item.status === STATUS.INACTIVE;
    
    return (
      <button
        onClick={() => handleOpenModal(item)}
        disabled={!isInactive}
        className={`px-4 py-1 rounded text-white transition ${
          isInactive 
            ? "bg-red-500 hover:bg-red-600 cursor-pointer" 
            : "bg-green-400 cursor-not-allowed"
        }`}
      >
        {isInactive ? "Action Pending" : "Renewed"}
      </button>
    );
  }, [handleOpenModal]);

  // Render Renew/Manual Table
  const renderDataTable = useCallback((tableData) => (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 text-sm">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-2 border">Order ID</th>
            <th className="p-2 border">Partner Code</th>
            <th className="p-2 border">ICCID</th>
            <th className="p-2 border">Plan Name</th>
            <th className="p-2 border">Renewal Days</th>
            <th className="p-2 border">Buy Amount</th>
            <th className="p-2 border">Renew Amount</th>
            <th className="p-2 border">Purchase Date</th>
            <th className="p-2 border">Request Date</th>
            <th className="p-2 border">New Expiry</th>
            <th className="p-2 border">Status</th>
            <th className="p-2 border">Action</th>
          </tr>
        </thead>
        <tbody>
          {tableData.length > 0 ? (
            tableData.map((item) => (
              <tr key={item.id || item.orderID} className="hover:bg-gray-50">
                <td className="p-2 border">{item.orderID}</td>
                <td className="p-2 border">{item.partnerCode}</td>
                <td className="p-2 border">{item.iccid}</td>
                <td className="p-2 border">{item.planName}</td>
                <td className="p-2 border">{item.renewalDays} Days</td>
                <td className="p-2 border">${parseFloat(item.buyAmount).toFixed(2)}</td>
                <td className="p-2 border">${parseFloat(item.userAmount).toFixed(2)}</td>
                <td className="p-2 border">{new Date(item.purchaseDate).toLocaleDateString()}</td>
                <td className="p-2 border">{new Date(item.createdDate).toLocaleDateString()}</td>
                <td className="p-2 border">{new Date(item.newExpiryDate).toLocaleDateString()}</td>
                <td className="p-2 border">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${
                    item.status === STATUS.INACTIVE 
                      ? 'bg-yellow-100 text-yellow-800' 
                      : 'bg-green-100 text-green-800'
                  }`}>
                    {item.status}
                  </span>
                </td>
                <td className="p-2 border">
                  {renderActionButton(item)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="p-2 border text-center text-gray-500" colSpan="12">
                No data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  ), [renderActionButton]);

  // Render Top-Up Table
  const renderTopupTable = useCallback(() => (
    <table className="w-full bg-white border rounded-lg shadow text-sm">
      <thead className="bg-gray-100">
        <tr className="border-b">
          <th className="text-center p-3 px-5">Plan Name</th>
          <th className="text-center p-3 px-5">Created Date</th>
          <th className="text-center p-3 px-5">Price</th>
          <th className="text-center p-3 px-5">Email</th>
          <th className="text-center p-3 px-5">ICCID</th>
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan="5" className="text-center py-4 text-gray-500">
              No top-up plans available.
            </td>
          </tr>
        ) : (
          data.map((item, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="text-center p-3 px-5">{item.planname}</td>
              <td className="text-center p-3 px-5">{item.createddate}</td>
              <td className="text-center p-3 px-5">${item.price}.00</td>
              <td className="text-center p-3 px-5">{item.email}</td>
              <td className="text-center p-3 px-5">{item.iccid?.trim()}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  ), [data]);

  // Refresh current view data
  const handleRefresh = useCallback(() => {
    setLoading(true);
    switch (currentView) {
      case VIEW_TYPES.TOPUP:
        fetchTopupHistory();
        break;
      case VIEW_TYPES.RENEW:
        fetchRenewData();
        break;
      case VIEW_TYPES.MANUAL:
        fetchManualActivationData();
        break;
      default:
        setLoading(false);
    }
    showToast("Data refreshed!", "success");
  }, [currentView, fetchTopupHistory, fetchRenewData, fetchManualActivationData, showToast]);

  return (
    <div className="p-6 overflow-x-auto relative">
      {/* Toast Notification */}
      {toast.show && (
        <Toast 
          message={toast.message} 
          type={toast.type} 
          onClose={hideToast} 
        />
      )}

      {/* Header Section */}
      <div className="flex justify-between items-center mb-4 flex-wrap gap-3">
        <h1 className="text-2xl font-bold">
          {viewConfig[currentView]?.title}
        </h1>
        
        <div className="flex gap-2 flex-wrap">
          {/* Refresh Button */}
          <button
            onClick={handleRefresh}
            disabled={loading}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded shadow flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Refresh
          </button>

          {/* Download CSV Button */}
          <button
            onClick={handleDownloadCSV}
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded shadow flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={loading || !viewConfig[currentView]?.hasData}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download CSV
          </button>

          {/* View Toggle Buttons */}
          <button
            onClick={() => handleViewChange(VIEW_TYPES.TOPUP)}
            className={`px-4 py-2 rounded shadow transition ${
              currentView === VIEW_TYPES.TOPUP
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300 text-gray-700"
            }`}
          >
            Top-Up History
          </button>

          <button
            onClick={() => handleViewChange(VIEW_TYPES.RENEW)}
            className={`px-4 py-2 rounded shadow transition ${
              currentView === VIEW_TYPES.RENEW
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300 text-gray-700"
            }`}
          >
            Renew Data
          </button>

          <button
            onClick={() => handleViewChange(VIEW_TYPES.MANUAL)}
            className={`px-4 py-2 rounded shadow transition ${
              currentView === VIEW_TYPES.MANUAL
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300 text-gray-700"
            }`}
          >
            Manual Activation
          </button>
        </div>
      </div>

      {/* Content Section */}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {currentView === VIEW_TYPES.TOPUP && renderTopupTable()}
          {currentView === VIEW_TYPES.RENEW && renderDataTable(renewData)}
          {currentView === VIEW_TYPES.MANUAL && renderDataTable(manualData)}
        </>
      )}

      {/* Modal */}
      {modalVisible && selectedOrder && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget && !modalLoading) {
              handleCloseModal();
            }
          }}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 w-96 relative animate-fade-in">
            {/* Close button */}
            <button
              onClick={handleCloseModal}
              disabled={modalLoading}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 disabled:opacity-50"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h2 className="text-lg font-semibold mb-4">
              {currentView === VIEW_TYPES.MANUAL ? "Update Manual Activation Status" : "Update Renewal Status"}
            </h2>
            
            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <p className="mb-2">
                <span className="text-gray-600">Order ID:</span>{" "}
                <strong className="text-gray-900">{selectedOrder.orderID}</strong>
              </p>
              <p className="text-sm text-gray-600">
                <span className="text-gray-600">Flag:</span>{" "}
                <strong className="text-gray-900">
                  {currentView === VIEW_TYPES.MANUAL ? FLAGS.MANUAL : FLAGS.RENEW}
                </strong>
              </p>
              <p className="text-sm text-gray-600 mt-2">
                <span className="text-gray-600">New Status:</span>{" "}
                <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
                  {STATUS.RECHARGE}
                </span>
              </p>
            </div>

            <p className="text-sm text-gray-500 mb-4">
              Are you sure you want to update the status for this order?
            </p>

            <div className="flex justify-between gap-3">
              <button
                onClick={handleCloseModal}
                disabled={modalLoading}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 flex-1 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleStatusUpdate}
                disabled={modalLoading}
                className="px-4 py-2 rounded text-white bg-blue-500 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed flex-1 flex items-center justify-center gap-2 transition"
              >
                {modalLoading ? (
                  <>
                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Updating...
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Confirm Update
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add CSS for animations */}
      <style jsx>{`
        @keyframes slide-in {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes fade-in {
          from {
            transform: scale(0.95);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        
        .animate-slide-in {
          animation: slide-in 0.3s ease-out;
        }
        
        .animate-fade-in {
          animation: fade-in 0.2s ease-out;
        }
      `}</style>
    </div>
  );
};

export default SuperadminRenewal;